import {
  gql 
} from "@apollo/client"

import {
  CartTriggerFragment 
} from "@/hooks/Header/cartTriggerFragments.gql"
import {
  MiniCartFragment 
} from "../MiniCart/miniCartFragments.gql.js"

export const ADD_PRODUCT_TO_CART = gql`
    mutation AddProductToCart($cartId: String!, $product: CartItemInput!) {
        addProductsToCart(cartId: $cartId, cartItems: [$product]) {
            cart {
                id
                ...CartTriggerFragment
                ...MiniCartFragment
            }
        }
    }
    ${CartTriggerFragment}
    ${MiniCartFragment}
`

export const GET_WISHLIST_CONFIG = gql`
    query GetWishlistConfigForProductMOS {
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        storeConfig {
            store_code
            magento_wishlist_general_is_enabled
        }
    }
`

/**
 * @deprecated - replaced by general mutation in @/hooks/productFullDetail.js
 */
export const ADD_CONFIGURABLE_MUTATION = gql`
    mutation addConfigurableProductToCart(
        $cartId: String!
        $quantity: Float!
        $sku: String!
        $parentSku: String!
    ) {
        addConfigurableProductsToCart(
            input: {
                cart_id: $cartId
                cart_items: [
                    {
                        data: { quantity: $quantity, sku: $sku }
                        parent_sku: $parentSku
                    }
                ]
            }
        ) {
            cart {
                id
                # Update the cart trigger when adding an item.
                ...CartTriggerFragment
                # Update the mini cart when adding an item.
                ...MiniCartFragment
            }
        }
    }
    ${CartTriggerFragment}
    ${MiniCartFragment}
`

/**
 * @deprecated - replaced by general mutation in @/hooks/productFullDetail.js
 */
export const ADD_SIMPLE_MUTATION = gql`
    mutation addSimpleProductToCart(
        $cartId: String!
        $quantity: Float!
        $sku: String!
    ) {
        addSimpleProductsToCart(
            input: {
                cart_id: $cartId
                cart_items: [{ data: { quantity: $quantity, sku: $sku } }]
            }
        ) {
            cart {
                id
                # Update the cart trigger when adding an item.
                ...CartTriggerFragment
                # Update the mini cart when adding an item.
                ...MiniCartFragment
            }
        }
    }
    ${CartTriggerFragment}
    ${MiniCartFragment}
`

export default {
  addConfigurableProductToCartMutation: ADD_CONFIGURABLE_MUTATION,
  addProductToCartMutation: ADD_PRODUCT_TO_CART,
  addSimpleProductToCartMutation: ADD_SIMPLE_MUTATION,
  getWishlistConfigQuery: GET_WISHLIST_CONFIG,
}
